import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "./UserContext";

interface PrivateRouteProps {
  requiredPermissions?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ requiredPermissions }) => {
  const { getUser, isLoggedIn } = useUserContext();
  const user = getUser();
  
  // if (!isLoggedIn) {
  //   return <Navigate to="/login" replace />;
  // }

  // if (
  //   requiredPermissions &&
  //   !requiredPermissions.some((perm) => user?.permissions?.includes(perm))
  // ) {
  //   return <Navigate to="/unauthorized" replace />;
  // }

  // return <Outlet />;
  // console.log(user)
  // console.log(isLoggedIn)
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }

  if (
    requiredPermissions &&
    requiredPermissions.length > 0 &&
    !requiredPermissions.some((perm) => user?.permissions?.includes(perm))
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
